/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TreeExpandIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Tree Expand',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M4 5v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Zm21.5 15H20v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V20h-5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H16v-5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h5.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5Z"
    />
  </svg>`;
};
